import { buildYourOwnValue } from './findNearestCaratValue';

export const getCenterDiamondSize = (exclusionOption: string[]) => {
  return Math.max(
    ...Object.keys(buildYourOwnValue)
      .filter(key => !exclusionOption?.includes(key))
      .map(Number)
  ).toString();
};